import AbstractCalls from "./AbstractCalls";

class PhotoCalls extends AbstractCalls {
  create(dtoIn, options) {
    return AbstractCalls.post(AbstractCalls.buildCallUri("main", "photo/create"), dtoIn, options);
  }

  uploaded(dtoIn, options) {
    return AbstractCalls.post(AbstractCalls.buildCallUri("main", "photo/uploaded"), dtoIn, options);
  }

  update(dtoIn, options) {
    return AbstractCalls.post(AbstractCalls.buildCallUri("main", "photo/update"), dtoIn, options);
  }

  delete(dtoIn, options) {
    return AbstractCalls.post(AbstractCalls.buildCallUri("main", "photo/delete"), dtoIn, options);
  }

  get(body, options) {
    return AbstractCalls.get(AbstractCalls.buildCallUri("main", "photo/get"), body, options);
  }

  list(body, options) {
    return AbstractCalls.get(AbstractCalls.buildCallUri("main", "photo/list"), body, options);
  }

  gallery(body, options) {
    return AbstractCalls.get(AbstractCalls.buildCallUri("main", "photo/gallery"), body, options);
  }
}

export default new PhotoCalls();
